import * as bootstrap from 'bootstrap'
import {useEffect, useState} from 'react'
import * as Yup from 'yup'
import {addUserUnit, listUnitTree} from '../../../../modules/auth/core/_requests'
import {AxiosError} from 'axios'
import {useFormik} from 'formik'
import {SuccessfulNotify, UnsuccessfulNotify} from '../../../../../ToastMetods'
import {KTSVG} from '../../../../../_metronic/helpers'
import TreeBuilder3 from '../../Components/TreeBuilder3'

const profileDetailsSchema = Yup.object().shape({
  unitId: Yup.number().required('Unit Id is required').min(1, 'Unit Id cannot be zero'),
})

function AddUserUnitModal({id, setAction}: any) {
  const [loading, setLoading] = useState(false)
  const [units, setUnits] = useState<[]>([])

  // Birim  Listesi
  const getListUnits = async () => {
    try {
      const {data} = await listUnitTree(0, 0)
      setUnits(data)
    } catch (err) {
      const error = `${(err as AxiosError)?.response?.data}`
      console.error(error)
    }
  }

  useEffect(() => {
    getListUnits()
  }, [])

  const initialValues = {
    unitId: 0,
    hiyerarsiMap: '',
  }

  const formik = useFormik({
    enableReinitialize: true,
    initialValues,
    validationSchema: profileDetailsSchema,
    onSubmit: async (values) => {
      setLoading(true)
      try {
        const {data} = await addUserUnit(id, values.unitId)
        formik.resetForm()
        //Modal close
        const modal = bootstrap.Modal.getOrCreateInstance('#createTabContentUnit_modal')
        modal.hide()
        //
        SuccessfulNotify('Registration Successfully Added.')
        setAction(true)

        setLoading(false)
      } catch (err) {
        const error = `${(err as AxiosError)?.response?.data}`
        console.error(error)
        UnsuccessfulNotify(String(error))
        setLoading(false)
      }
    },
  })

  const SelectedTags = (tags: any) => {
    formik.setFieldValue('hiyerarsiMap', tags)
  }

  const SelectedUnits = (unitId: any) => {
    formik.setFieldValue('unitId', unitId)
  }

  return (
    <div className='modal fade' tabIndex={-1} id='createTabContentUnit_modal'>
      <div className='modal-dialog modal-dialog-centered'>
        <div className='modal-content'>
          <div className='modal-header'>
            <h5 className='modal-title'>Add User Unit</h5>
            <div
              className='btn btn-icon btn-sm btn-active-light-primary ms-2'
              data-bs-dismiss='modal'
              aria-label='Close'
            >
              <KTSVG
                path='/media/icons/duotune/arrows/arr061.svg'
                className='svg-icon svg-icon-2x'
              />
            </div>
          </div>
          <div className='modal-body'>
            <form onSubmit={formik.handleSubmit} noValidate className='form'>
              <div className='modal-body'>
                {/*From*/}

                {/* 👇 Role 👇 */}
                <div className='col'>
                  <div className='border border-dashe rounded border-1'>
                    <TreeBuilder3
                      SetUstBirimId={SelectedUnits}
                      setHiyerarsiMap={SelectedTags}
                      loop={1}
                      birims={units}
                    />
                  </div>
                  <div className='d-flex justify-content-end'>
                    <span className='badge badge-light-primary mt-2'>
                      Selected Unit :
                      <span className='badge bg-light text-dark'>
                        {formik.values.hiyerarsiMap !== '' ? formik.values.hiyerarsiMap : 'empty'}
                      </span>
                    </span>
                  </div>
                  {/*}
                      <label className='form-label fw-bold'>Unit</label>
                  <select
                    className='form-select form-select-solid'
                    data-kt-select2='true'
                    data-placeholder='Select option'
                    data-allow-clear='true'
                    value={formik.getFieldProps('unitId').value}
                    onChange={(e) => formik.setFieldValue('unitId', Number(e.target.value))}
                  >
                    {units.map((item: any, index: number) => (
                      <option key={index} value={item.id}>
                        {item.name}
                      </option>
                    ))}
                  </select>
                  {*/}
                </div>
                {/* 👆 Role 👆 */}

                {/*End Form */}
              </div>
              <div className='modal-footer'>
                <button type='button' className='btn btn-light' data-bs-dismiss='modal'>
                  Close
                </button>

                <button type='submit' className='btn btn-primary'>
                  Save
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  )
}

export default AddUserUnitModal
